import type { IxcRegistrationV1Phone } from '@interxfi/types';

export function normalizePhone(phone: IxcRegistrationV1Phone | undefined): IxcRegistrationV1Phone | undefined {
  if (!phone) {
    return undefined;
  }

  return {
    ...phone,
    sms: Boolean(phone.sms),
    voice: Boolean(phone.voice),
  };
}

export function formatPhone(phone: IxcRegistrationV1Phone | undefined) {
  if (!phone) {
    return '';
  }

  return [
    phone.number,
    [phone.label, [phone.sms ? 'SMS' : undefined, phone.voice ? 'Voice' : undefined].filter(Boolean).join(', ')].filter(Boolean).join(' '),
  ]
    .filter(Boolean)
    .join('\n');
}
